<mat-form-field appearance="outline" class="flex-1">
  <mat-label>{{label()}}</mat-label>
  <div matSuffix="" class="flex items-center">
    @if (isLoadingTaxPartners === true) {
      <mat-spinner diameter="14" class="mx2"></mat-spinner>
    }
  </div>
  <input [formControl]="control()" type="text" matInput="" [matAutocomplete]="taxPartnerAutoComplete" [required]="required() !== false" [attr.cdkFocusInitial]="focus() !== false ? 'true' : null" autocomplete="off">
  <mat-autocomplete autoActiveFirstOption="" #taxPartnerAutoComplete="matAutocomplete" [displayWith]="displayWithCustomer">
    @if (required() === false) {
      <mat-option [value]="null">
        <span translate="">None</span>
      </mat-option>
    }
    @for (taxPartner of taxPartnersFiltered; track taxPartner) {
      <mat-option [value]="taxPartner">
        @if (taxPartner.type == 'Person') {
          <mat-icon class="icon-small mr1">person_outline</mat-icon>
        }
        {{taxPartner.name}} @if (taxPartner.email) {
        <span class="gray">({{taxPartner.email}})</span>
      }
    </mat-option>
  }
</mat-autocomplete>
</mat-form-field>